'use strict'

// import TableServer from '../../../../components/Table/Table.vue'
// import TableCellObject from '../../../../components/Table/TableCellObject.vue'
// import StockConfigurationDepartmentSelector from './StockConfigurationDepartmentSelector.vue'
import { EventBus } from '../../../../EventBus/EventBus.js'
import { axiosPost } from '../../../../axios/axios.js'

export default {
  // name: 'StockControl',
  // components: {
  //   TableServer,
  //   TableCellObject,
  //   StockConfigurationDepartmentSelector
  // },
  props: {
    stockId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    },
    defaultDepartmentId: {
      type: Number,
      default: null
    },
    stockControlRecordId: {
      type: Number,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const vm = this

    return {
      departmentSelectorConfig: {
        loading: false,
        defaultDepartmentId: this.defaultDepartmentId,
        departmentId: null,
        department: null,
        departments: [],
        get hasChanges () {
          return vm.hasChanges
        },
        get readonly () {
          return vm.readonly || vm.stockControlRecordIdLocal != null
        }
      },

      stockControlRecordIdLocal: this.stockControlRecordId || this.stockControl && this.stockControl.stockControlRecord && this.stockControl.stockControlRecord.id || null,

      updateEvent: 'update-stockToolControlResult',
      itemMapper: item => {
        // const amount = item.amount || 0
        // item.amount = amount
        // item.actualAmount = amount

        const controlResult = item.controlResult && item.controlResult.id || null
        item.controlResult = controlResult
        item.controlResultInitial = controlResult
        Object.defineProperty(item, 'controlResultPresent', {
          get: function () {
            return this.controlResult === 'present'
          },
          set: function (value) {
            this.controlResult = value ? 'present' : 'notChecked' // 'absent'
          }
        })
        Object.defineProperty(item, 'controlResultAbsent', {
          get: function () {
            return this.controlResult === 'absent'
          },
          set: function (value) {
            this.controlResult = value ? 'absent' : 'notChecked' // 'present'
          }
        })
        Object.defineProperty(item, 'controlResultReady', {
          get: function () {
            return this.controlResult != null && this.controlResult !== 'notChecked'
          }
        })
        Object.defineProperty(item, 'changed', {
          get: function () {
            return this.controlResult != this.controlResultInitial
          }
        })
        return item
      },

      allItemsChecked: false,
      changedItems: [],
      changedItemsIds: new Set(),

      loading: false
    }
  },
  computed: {
    hasEditAccess: function () {
      return this.$d_hasOperation('stockAccessoryControl')
    },
    hasChanges: function () {
      return !!(this.changedItems && this.changedItems.length)
    },
    saveChangesDisabled: function () {
      return !this.allItemsChecked || !this.hasChanges
    },
    performed: function () {
      return this.stockControlRecordIdLocal != null && !this.skipped
    },
    skipped: function () {
      return !!this.stockControl.stockControlRecord && !!this.stockControl.stockControlRecord.skipped
    }
  },
  watch: {
    'departmentSelectorConfig.departmentId': function (id) {
      this.clearChanges(true)

      this.onDepartmentsChanged()
    }
  },
  mounted: function () {
    EventBus.$on(this.updateEvent, this.onUpdateEvent)
  },
  beforeDestroy: function () {
    EventBus.$off(this.updateEvent, this.onUpdateEvent)
  },
  methods: {
    // @Abstract
    getItems: function () {
    },
    // @Abstract
    onUpdateRecord: function () {
    },
    // @Abstract
    onRecordCreated: function (recordId) {
    },
    // @Abstract
    onDepartmentsChanged: function (recordId) {
    },

    // onTableItemsUpdated: function (event) {
    //   this.updateAllItemsChecked(event.data)
    // },
    onUpdateEvent: function (event) {
      if (event && event.target != this) {
        this.clearChanges(true)
      }
    },

    updateAllItemsChecked: function (items) {
      if (items == null) {
        items = this.getItems()
      }

      let allItemsChecked = false
      if (items && items.length) {
        allItemsChecked = true
        for (const item of items) {
          if (!item.controlResultReady) { // !!!
            allItemsChecked = false
            break
          }
        }
      }

      this.allItemsChecked = allItemsChecked
    },
    onCheckItem: function (item, isChecked, checkProperty, ignoreAll) {
      if (!this.hasEditAccess) {
        return
      }

      // item.isChecked = isChecked
      item[checkProperty] = isChecked

      if (this.changedItemsIds.has(item.id)) {
        if (!item.changed) {
          this.changedItemsIds.delete(item.id)
          const selectedIndex = this.changedItems.findIndex(element => element.id == item.id)
          if (selectedIndex !== -1) {
            this.changedItems.splice(selectedIndex, 1)
          }
        }
      } else {
        if (item.changed) {
          this.changedItemsIds.add(item.id)
          this.changedItems.push(item)
        }
      }

      if (!ignoreAll) {
        this.updateAllItemsChecked()
      }
    },
    onClearChanges: function () {
      this.clearChanges(true)
    },
    clearChanges: function (notify) {
      if (this.changedItemsIds.size) {
        const items = this.getItems()
        items.forEach(item => {
          if (item.changed) {
            item.controlResult = item.controlResultInitial
          }
        })
        this.changedItems = []
        this.changedItemsIds = new Set()

        this.updateAllItemsChecked()

        if (notify) {
          this.$q.notify({
            type: 'warning',
            message: 'Изменения сброшены',
            progress: true,
            timeout: 3000
          })
        }
      }
    },
    onSaveChanges: function () {
      if (!this.hasEditAccess) {
        this.$q.notify({
          type: 'negative',
          message: 'Нет доступа на редактирование',
          progress: true,
          timeout: 4000
        })
        return
      }

      if (this.saveChangesDisabled) {
        this.$q.notify({
          type: !this.hasChanges ? 'warning' : 'negative',
          message: !this.hasChanges ? 'Нет изменений' : 'Не все позиции проверены',
          progress: true,
          timeout: 4000
        })
        return
      }

      this.loading = true

      const bodyFormData = new FormData()
      bodyFormData.set('stockId', this.stockId)
      bodyFormData.set('depId', this.departmentSelectorConfig.departmentId)
      const toolsChanges = this.changedItems.map(item => {
        return { id: item.id, controlResult: item.controlResult }
      })
      bodyFormData.set('changes', JSON.stringify({ result: toolsChanges }))
      if (this.stockControlRecordIdLocal != null) {
        bodyFormData.set('stockControlRecordId', this.stockControlRecordIdLocal)
      }
      if (this.stockControl) { // TODO stockControl !!!
        const stockControl = this.stockControl
        if (stockControl.vehicleIssuance) {
          bodyFormData.set('vehicleIssuanceRecordId', stockControl.vehicleIssuance.id)
        }
        if (stockControl.stage) {
          bodyFormData.set('stage', stockControl.stage)
        }
      }

      return axiosPost({
        url: 'service/delta/stock/control/record/edit',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Результаты контроля наличия успешно сохранены',
            progress: true,
            timeout: 3000
          })

          if (this.stockControlRecordIdLocal == null) {
            this.stockControlRecordIdLocal = response.data.id

            EventBus.$emit('update-stockControlRecord')

            this.onRecordCreated(response.data.id)
          } else {
            this.onUpdateRecord()
          }

          this.$emit('record-saved', this.stockControlRecordIdLocal)
          // this.clearChanges(false)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка сохранения результатов контроля наличия',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
